var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.358 0.831058C13.8103 1.20298 12.4906 3.97443 11.3868 6.64989C10.283 9.32536 10.283 9.32536 10.283 9.32536C10.283 9.32536 0.684936 9.21738 0.384996 11.065C0.085056 12.9006 6.80371 18.7675 6.80371 18.7675C6.80371 18.7675 4.83611 26.206 5.20803 27.6337C5.57996 29.0734 6.01187 29.1934 7.54756 28.9414C9.08326 28.6775 14.9261 24.9102 14.9261 24.9102C14.9261 24.9102 22.5686 29.7213 23.7923 29.1214C25.6879 28.2216 23.1804 18.4075 23.1804 18.4075C23.1804 18.4075 28.8073 14.6283 29.6471 12.8047C30.487 10.993 29.1073 10.2732 27.6915 10.2132C26.2758 10.1532 19.9651 9.86525 19.9651 9.86525C19.9651 9.86525 16.9057 0.459133 15.358 0.831058Z",
    fill: "url(#paint0_linear_23_3415)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23_3415",
    x1: 15.139,
    y1: 0.820312,
    x2: 15.139,
    y2: 29.1732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAA2B"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.f0d998acdb2ec2e853f5a1f9e743d2d8.svg";
export { ForwardRef as ReactComponent };